import dashboardApi from 'services/api/dashboard'

import { monthsShort } from '../utils/helpers'
import {
  OTA_COMMISSION_MULTIPLIER,
  sliceLastTwelveMonthsExceptOne
} from '../utils/insightsHelpers'
import {
  GET_INSIGHTS_FAILED,
  GET_INSIGHTS_STARTED,
  GET_INSIGHTS_SUCCESS,
  GET_ONE_TIME_GUEST_DATA_SUCCESS,
  GET_REPEAT_GUEST_DATA_SUCCESS
} from './actionTypes'

export const getInsights = () => {
  return async dispatch => {
    dispatch({
      type: GET_INSIGHTS_STARTED
    })

    try {
      let oneTimerAnnualGuests
      let repeatAnnualGuests
      let reservationLengthInsights
      let guestInsights

      try {
        oneTimerAnnualGuests = await dashboardApi.oneTimerAnnualGuests()
      } catch (error) {
        if (error.includes('SessionTimedOut')) return
      }

      try {
        repeatAnnualGuests = await dashboardApi.repeatAnnualGuests()
      } catch (error) {
        if (error.includes('SessionTimedOut')) return
      }

      try {
        guestInsights = await dashboardApi.guestInsights()
      } catch (error) {
        if (error.includes('SessionTimedOut')) return
      }

      try {
        reservationLengthInsights = await dashboardApi.reservationLengthInsights()
      } catch (error) {
        if (error.includes('SessionTimedOut')) return
      }

      const { otaPerformances, directPerformances, invitePerformances } = guestInsights

      dispatch({
        type: GET_INSIGHTS_SUCCESS,
        payload: {
          reservationLengthInsights: reservationLengthInsights
            ? {
                thisYear: reservationLengthInsights.nightsSummaries
                  .filter(o => o.checkOutYear === new Date().getFullYear() - 1)
                  .map(o => ({
                    name: o.duration,
                    bookings: o.totalBookings
                  })),
                averageNights: reservationLengthInsights.averageNights
              }
            : null,
          invitePerformances:
            invitePerformances && invitePerformances.length
              ? {
                  last12Months: sliceLastTwelveMonthsExceptOne(invitePerformances).map(
                    o => ({
                      name: monthsShort[Number(o.checkOutMonth) - 1],
                      totalRate: o.totalRate,
                      numberOfGuests: o.totalGuests
                    })
                  ),
                  summary: {
                    numberOfGuests: invitePerformances
                      .map(o => o.totalGuests)
                      .reduce((prev, curr) => prev + curr, 0),
                    totalRevenue: Number(
                      invitePerformances
                        .map(o => o.totalRate)
                        .reduce((prev, curr) => prev + curr, 0)
                        .toFixed(2)
                    ),
                    totalNights: invitePerformances
                      .map(o => o.totalNights)
                      .reduce((prev, curr) => prev + curr, 0)
                  }
                }
              : null,
          otaPerformances: otaPerformances
            ? {
                last3yearsMonthly: otaPerformances
                  .filter((v, i, arr) => v.checkOutYear < arr[0].checkOutYear + 3)
                  .reduce((prev, curr) => {
                    const match = prev[curr.checkOutMonth] || {}

                    return {
                      ...prev,
                      [curr.checkOutMonth]: {
                        ...match,
                        name: monthsShort[Number(curr.checkOutMonth) - 1],
                        [curr.checkOutYear]: Number(
                          (curr.totalRate * OTA_COMMISSION_MULTIPLIER).toFixed(2)
                        )
                      }
                    }
                  }, {}),
                last12Months: sliceLastTwelveMonthsExceptOne(otaPerformances).map(o => ({
                  name: monthsShort[Number(o.checkOutMonth) - 1],
                  comission: Number((o.totalRate * OTA_COMMISSION_MULTIPLIER).toFixed(2))
                }))
              }
            : null,
          directPerformances: directPerformances
            ? {
                last3yearsMonthly: directPerformances
                  .filter((v, i, arr) => v.checkOutYear < arr[0].checkOutYear + 3)
                  .reduce((prev, curr) => {
                    const match = prev[curr.checkOutMonth] || {}

                    return {
                      ...prev,
                      [curr.checkOutMonth]: {
                        ...match,
                        name: monthsShort[Number(curr.checkOutMonth) - 1],
                        [curr.checkOutYear]: curr.totalGuests
                      }
                    }
                  }, {}),
                last12Months: sliceLastTwelveMonthsExceptOne(directPerformances).map(
                  o => ({
                    name: monthsShort[Number(o.checkOutMonth) - 1],
                    numberOfBookings: o.totalGuests,
                    numberOfNights: o.totalNights
                  })
                )
              }
            : null
        }
      })

      dispatch({
        type: GET_ONE_TIME_GUEST_DATA_SUCCESS,
        payload: oneTimerAnnualGuests
          .filter((_v, i) => i < 3)
          .map(annualData => ({
            year: annualData.checkOutYear,
            totalGuests: annualData.totalReservations,
            totalRepeatingClients: annualData.totalRepeatingClients,
            data: [
              {
                name: 'One time guests',
                value: annualData.oneTimeClientsPercentage
              },
              {
                name: 'Returning guests',
                value: 100 - annualData.oneTimeClientsPercentage
              }
            ]
          }))
      })

      dispatch({
        type: GET_REPEAT_GUEST_DATA_SUCCESS,
        payload: repeatAnnualGuests
          ? {
              last2yearsMonthly: repeatAnnualGuests
                .filter(v => {
                  return [
                    new Date().getFullYear() - 1,
                    new Date().getFullYear() - 2
                  ].includes(v.checkOutYear)
                })
                .reduce((prev, curr) => {
                  const match = prev[curr.repeatTimes] || {}
                  return {
                    ...prev,
                    [curr.repeatTimes]: {
                      ...match,
                      name: curr.repeatTimes,
                      [curr.checkOutYear]: curr.guestsInRepeatCount
                    }
                  }
                }, {}),
              last3yearsMonthly: repeatAnnualGuests
                .filter((v, i, arr) => v.checkOutYear < arr[0].checkOutYear + 3)
                .reduce((prev, curr) => {
                  const match = prev[curr.repeatTimes] || {}
                  return {
                    ...prev,
                    [curr.repeatTimes]: {
                      ...match,
                      name: curr.repeatTimes,
                      [curr.checkOutYear]: curr.guestsInRepeatCount
                    }
                  }
                }, {}),
              thisYear: repeatAnnualGuests
                .filter(v => v.checkOutYear === new Date().getFullYear() - 1)
                .map(o => ({
                  name: o.repeatTimes,
                  guests: o.guestsInRepeatCount
                }))
            }
          : null
      })
    } catch (err) {
      dispatch({
        type: GET_INSIGHTS_FAILED,
        payload: err
      })
    }
  }
}
